import { render, staticRenderFns } from "./detailsPost.vue?vue&type=template&id=6bb92fab&"
import script from "./detailsPost.vue?vue&type=script&lang=js&"
export * from "./detailsPost.vue?vue&type=script&lang=js&"
import style0 from "./detailsPost.vue?vue&type=style&index=0&id=6bb92fab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports